const koKR = {
  'modal.close': '닫기',
  'session_expired.title': '세션이 종료되었습니다',
  'tokenizationForm.payment-terms.text1': 'Flywire가 {{recipientName}} 대신 직불/신용카드를 자동으로 저장하고 청구하도록 승인합니다. 다음 내용을 읽고 이해하였으며 이에 동의합니다',
  'tokenizationForm.general-terms.link2': '개인정보 보호정책',
  'tokenizationForm.general-terms.link-joint': ' 그리고 ',
  'tokenizationForm.general-terms.link1': '사용약관',
  'tokenizationForm.payment-terms.link': 'Flywire 자동 결제 이용 약관',
  'tokenizationForm.labels.cvvTooltip': '카드 뒷면의 숫자 3자리 또는 앞면의 숫자 4자리',
  'tokenizationForm.labels.cvv': 'CVV',
  'tokenizationForm.labels.expiryDate': '만료일(월/년)',
  'tokenizationForm.labels.cardNumber': '카드 번호',
  'tokenizationForm.labels.phone': '전화번호',
  'tokenizationForm.labels.upopPhone': '이 은행 카드와 연결된 휴대폰 번호를 입력해 주십시오',
  'tokenizationForm.labels.zip': '우편번호',
  'tokenizationForm.labels.address': '주소',
  'cardsForm.labels.state': '주',
  'tokenizationForm.labels.country': '국가 또는 지역',
  'tokenizationForm.labels.city': '도시',
  'tokenizationForm.labels.email': '이메일',
  'tokenizationForm.labels.lastName': '성',
  'tokenizationForm.labels.firstName': '이름',
  'cardsForm.title': '카드 소지자 정보',
  'success.title': '결제하신 내역을 송금 중입니다',
  'success.title.info': '입금 확인까지는 보통 영업일 기준 2~3일이 소요됩니다. 입금이 확인되면 알림 메일을 발송해드립니다.',
  'bankAccountForm.hints.generic': '예시: {{label}}',
  'bankAccountForm.hints.account_number': '계좌 번호 길이는 1~17자 사이여야 합니다',
  'bankAccountForm.hints.routing_number': '라우팅 번호 길이는 9자리여야 합니다',
  'bankAccountForm.labels.accountZipCode': '우편번호',
  'bankAccountForm.labels.accountIban': 'IBAN',
  'bankAccountForm.labels.accountBicCode': 'BIC 코드',
  'bankAccountForm.labels.accountNumber': '계좌 번호',
  'bankAccountForm.labels.accountSortCode': '분류 코드',
  'bankAccountForm.labels.accountRoutingNumber': '라우팅 번호',
  'bankAccountForm.labels.accountType': '계좌 유형',
  'bankAccountForm.labels.eftProviderWidnow': '결제를 완료하기 위해 파트너사의 결제 처리 플랫폼으로 이동합니다. 작업이 완료되면 이 페이지로 다시 돌아옵니다.',
  'bankAccountForm.labels.termsFlywire': '<a class=\'fw-underline fw-text-primary-600\' href=\'https://www.flywire.com/terms/\' target=\'_blank\' rel=\'noopener noreferrer\' data-testid=\'termsOfUseLink\'>Flywire 이용 약관</a> 및 <a class=\'fw-underline fw-text-primary-600\' href=\'https://www.flywire.com/privacy/\' target=\'_blank\' data-testid=\'privacyPolicyLink\' rel=\'noopener noreferrer\'>개인정보 보호정책</a>을 읽고 이해했으며 이에 동의합니다',
  'bankAccountForm.labels.termsDirectDebit': '이 계좌의 소유자이며, 이 자동 이체를 승인해야 할 유일한 서명인임을 확인합니다',
  'bankAccountForm.labels.termsEft': '<a class=\'fw-underline fw-text-primary-600\' href=\'https://opu.myonplanu.com/pdf/pad-agreement.pdf\' target=\'_blank\' rel=\'noopener noreferrer\'>사전 승인 직불 계약</a>을 읽고, 이해하였으며, 동의합니다',
  'bankAccountForm.labels.city': '도시',
  'bankAccountForm.labels.country': '국가 또는 지역',
  'bankAccountForm.labels.selectCountry': '국가 또는 지역 선택',
  'bankAccountForm.title': '계정 소유자 정보',
  'failure.tryAgain': '다시 시도',
  'failure.title': '거래 실패',
  'failure.connectivity.message': '작업에 실패했습니다. 인터넷 연결 문제가 원인일 수 있습니다.',
  'failure.message': '거래에 실패했습니다. 이는 연결 문제 때문일 수 있습니다. 다시 시도하세요. 문제가 지속되면 다른 결제 수단을 시도하거나 거래 은행에 문의하세요.',
  'sessionExpired.text': '세션이 만료되었습니다',
  'LoadingError.title': '문제가 발생했습니다',
  'LoadingError.message': '양식을 로드하는 중 오류가 발생했습니다',
  'tokenizationForm.errors.noPaymentOptionsAvailable': '선택한 국가/지역에 사용할 수 있는 결제 옵션이 없습니다',
  'offerError.noOptions.card': 'The selected card type is not supported. Please use a different card type.',
  'offerError.noOptions.bank': 'The selected bank account is not supported. Please use a different bank account.',
  'offerError.noOptions.other': 'The selected Payment Method is not supported. Please use a different Payment Method.',
  'bankAccountForm.labels.accountHolderType.personal': '개인 계정',
  'bankAccountForm.labels.accountHolderType.business': '비즈니스 계좌',
  'bankAccountForm.labels.name': '이름',
  'bankAccountForm.labels.businessName': '비즈니스 이름',
  'bankAccountForm.labels.surname': '성',
  'bankAccountForm.labels.phone': '전화번호',
  'bankAccountForm.labels.email': '이메일',
  'bankAccountForm.labels.zip': '우편번호',
  'bankAccountForm.labels.accountAddress': '주소',
  'bankAccountForm.labels.address': '주소',
  'bankAccountForm.errors.dynamicFields': '유효하지 않은 {{field}}',
  'bankAccountForm.labels.saveButton': '저장',
  'bankAccountForm.labels.nextButton': '다음',
  'bankAccountForm.labels.payButton': '결제',
  'bankAccountForm.errors.cardNumber': '유효하지 않은 카드 번호',
  'tokenizationForm.errors.cardNumber': '유효하지 않은 카드 번호',
  'tokenizationForm.errors.cvv': '유효하지 않은 CVV 번호',
  'bankAccountForm.errors.cvv': '유효하지 않은 CVV 번호',
  'tokenizationForm.errors.unsupportedCardTypes': '{{acceptedCardsList}}만 지원됩니다',
  'tokenizationForm.errors.unsupportedCardType': '{{acceptedCard}}만 지원됩니다',
  'tokenizationForm.errors.cardType.and': '그리고',
  'tokenizationForm.errors.name': '유효하지 않은 이름',
  'tokenizationForm.errors.email': '잘못된 이메일 주소',
  'tokenizationForm.errors.country': '잘못된 국가 또는 지역',
  'tokenizationForm.errors.state': '유효하지 않은 상태',
  'tokenizationForm.errors.city': '유효하지 않은 도시',
  'tokenizationForm.errors.address': '유효하지 않은 주소',
  'tokenizationForm.errors.addressIsPoBox': '주소 필드에 사서함은 허용되지 않습니다.',
  'tokenizationForm.errors.onlyLetterOrNumbers': '유효한 문자에는 A-Z 및 0-9만 포함됩니다',
  'tokenizationForm.errors.onlyLetterOrNumbersOrSymbol': '유효한 문자에는 A-Z, 0-9 및 "/, -"만 포함됩니다',
  'tokenizationForm.errors.zip': '유효하지 않은 우편번호',
  'tokenizationForm.errors.expiryDate': '유효하지 않은 만료일',
  'bankAccountForm.errors.expiryDate': '유효하지 않은 만료일',
  'tokenizationForm.errors.surname': '유효하지 않은 성',
  'tokenizationForm.errors.phone': '유효하지 않은 전화번호',
  'tokenizationForm.errors.length': '필드가 너무 깁니다(최대 256자)',
  'tokenizationForm.errors.required.field': '필수 필드',
  'bankAccountForm.errors.name': '유효하지 않은 이름',
  'bankAccountForm.errors.name.maxSizeExceeded': '이름이 너무 깁니다(최대 140자)',
  'form.errors.name.maxSizeExceeded': '이름이 너무 깁니다(최대 {{limit}}자)',
  'form.errors.surname.maxSizeExceeded': '성이 너무 깁니다(최대 {{limit}}자)',
  'form.errors.business_name.maxSizeExceeded': '비즈니스 이름이 너무 깁니다(최대 {{limit}}자)',
  'form.errors.city.maxSizeExceeded': '도시가 너무 깁니다(최대 {{limit}}자)',
  'form.errors.address.maxSizeExceeded': '주소가 너무 깁니다(최대 {{limit}}자)',
  'form.errors.date.wrongDate': '유효하지 않은 날짜 선택기 값',
  'bankAccountForm.errors.business_name': '유효하지 않은 비즈니스 이름',
  'bankAccountForm.errors.business_name.maxSizeExceeded': '비즈니스 이름이 너무 깁니다(최대 140자)',
  'bankAccountForm.errors.surname': '유효하지 않은 성',
  'bankAccountForm.errors.surname.maxSizeExceeded': '성이 너무 깁니다(최대 140자)',
  'bankAccountForm.errors.country': '잘못된 국가 또는 지역',
  'bankAccountForm.errors.address': '유효하지 않은 주소',
  'bankAccountForm.errors.address.maxSizeExceeded': '주소가 너무 깁니다(최대 256자)',
  'bankAccountForm.errors.city': '유효하지 않은 도시',
  'bankAccountForm.errors.city.maxSizeExceeded': '도시가 너무 깁니다(최대 256자)',
  'bankAccountForm.errors.email': '잘못된 이메일 주소',
  'bankAccountForm.errors.state': '유효하지 않은 상태',
  'bankAccountForm.errors.iban': '유효하지 않은 IBAN',
  'bankAccountForm.errors.bic': '유효하지 않은 BIC 코드',
  'bankAccountForm.errors.accountnumber': '유효하지 않은 계좌 번호',
  'bankAccountForm.errors.sortcode': '유효하지 않은 은행 식별 기호',
  'bankAccountForm.errors.account_type': '유효하지 않은 계좌 유형',
  'bankAccountForm.errors.addressIsPoBox': '주소 필드에 사서함은 허용되지 않습니다.',
  'bankAccountForm.errors.onlyLetterOrNumbers': '유효한 문자에는 A-Z 및 0-9만 포함됩니다',
  'bankAccountForm.errors.onlyLetterOrNumberOrSymbol': '유효한 문자는 다음과 같습니다: A-Z 0-9 / , -',
  'bankAccountForm.errors.zip': '유효하지 않은 우편번호',
  'bankAccountForm.errors.phone': '유효하지 않은 전화번호',
  'bankAccountForm.errors.ach_account_number': '유효하지 않은 계좌 번호',
  'bankAccountForm.errors.routing_number': '유효하지 않은 라우팅 번호',
  'bankAccountForm.errors.offer': '사용할 수 있는 결제 수단이 없습니다. 다른 국가/지역에 은행 계좌가 있는 경우 해당 국가/지역을 선택하거나 다른 카드를 선택하여 다시 시도하세요. 그래도 문제가 해결되지 않으면 {{recipientName}}에 문의하세요',
  'binLookUp.unableToFindCard.message': '카드 오류가 발생했습니다. 입력한 카드 세부 정보를 검토하거나 다른 카드를 사용해 보세요.',
  'binLookUp.warning.message': '카드를 확인할 수 없습니다',
  'confirmationPage.labels.edit': '편집',
  'confirmationPage.labels.confirm': '확인',
  'confirmationPage.labels.title': '필수 정보 검토',
  'confirmationPage.labels.typeOfPayment': '결제 유형',
  'confirmationPage.labels.paymentRecipient': '결제 수령자',
  'confirmationPage.labels.typeOfPayment.oneOff': '일회성',
  'confirmationPage.labels.typeOfPayment.recurring': '반복',
  'confirmationPage.labels.directDebitInformation': '자동 이체 정보',
  'confirmationPage.labels.directDebitInformation.title': '은행에 안내할 정보',
  'confirmationPage.labels.directDebitInformation.creditor': '수취인',
  'confirmationPage.labels.directDebitInformation.creditorId': '수취인 ID',
  'confirmationPage.labels.directDebitInformation.serviceUserStatement': '내 결제 내역의 이름',
  'confirmationPage.labels.directDebitInformation.serviceUserId': '서비스 사용자 ID',
  'confirmationPage.labels.directDebitInformation.address': 'Flywire 주소',
  'confirmationPage.labels.directDebitInformation.originator': 'Originator',
  'confirmationPage.labels.directDebitInformation.originatorId': 'Originator ID',
  'confirmationPage.labels.directDebitInformation.originatorAddress': 'Originator 주소',
  'confirmationPage.labels.bankAccountInformation': '은행 계좌 정보',
  'confirmationPage.labels.bankAccountInformation.name': '이름',
  'confirmationPage.labels.bankAccountInformation.iban': 'IBAN 번호',
  'confirmationPage.labels.bankAccountInformation.email': '이메일',
  'confirmationPage.labels.bankAccountInformation.country': '국가 또는 지역',
  'confirmationPage.labels.bankAccountInformation.state': '주',
  'confirmationPage.labels.bankAccountInformation.city': '도시',
  'confirmationPage.labels.bankAccountInformation.bicCode': 'BIC 코드',
  'confirmationPage.labels.bankAccountInformation.accountNumber': '계좌 번호',
  'confirmationPage.labels.bankAccountInformation.sortCode': '분류 코드',
  'confirmationPage.labels.bankAccountInformation.achAccountNumber': '계좌번호',
  'confirmationPage.labels.bankAccountInformation.routingNumber': '라우팅 번호',
  'confirmationPage.labels.bankAccountInformation.accountType': '계좌 유형',
  'confirmationPage.labels.paymentInformation': '결제 정보',
  'confirmationPage.labels.paymentInformation.amount': '금액',
  'confirmationPage.labels.changeAccountEft': '은행 계좌 세부 정보 변경',
  'confirmationPage.labels.editPayerEft': '결제자 세부 정보 편집',
  'confirmationPage.labels.useAccountEft': '끝자리가 **** {{lastFour}}인 계좌 사용',
  'confirmationPage.labels.bankLinkSuccessMessage': '은행 계좌가 성공적으로 연결되었습니다',
  'confirmationPage.labels.termsSepa': '이 필수 양식에 서명함으로써, (A) FLYWIRE EUROPE UAB가 고객님의 계좌에서 대금을 인출할 수 있도록 거래 은행에 안내문을 보내고 (B) 거래 은행이 FLYWIRE EUROPE UAB의 안내문에 따라 계좌에서 대금을 인출하는 것을 승인하시게 됩니다. 대금 청구로부터 최소 3일 전에 통지를 드립니다.',
  'confirmationPage.labels.termsBacs': '자동 이체 보증으로 보장되는 안전 장치를 적용해 이 지침에 명시된 계좌에서 Flywire Payments Limited에 자동 이체로 결제하도록 은행에 안내합니다. 이 안내가 Flywire Payments Limited에 보존될 수 있으며, 이 경우 세부 정보가 전자식으로 내 은행/주택금융조합으로 전달되는 것을 이해합니다.',
  'confirmationPage.labels.termsAch': '\n     "확인"을 클릭하면, 회원님이 적절한 권한을 보유하고 있으며, 지정된 수취인을 대신하여 Flywire가 회원님이 제공한 은행 계좌에서 수취인의 서비스 이용 및/또는 제품 구매로 발생한 금액을 인출하고, 필요한 경우 수취인의 약관에 따라 잘못된 인출을 수정하도록 승인함을 확인하는 것이며, 이는 승인을 취소될 때까지 유효합니다. ACH 거래가 자금 부족으로 거부될 경우 NSF 수수료가 부과되며, Flywire는 자체 재량에 따라 결제를 다시 처리할 수 있음을 이해합니다.\n     ',
  'confirmationPage.labels.termsAch2': '\n     수취인의 추가 제품 및/또는 서비스를 주기적으로 사용하거나 구매하는 경우, 회원님은 수취인의 조건에 따라 Flywire가 수취인을 대신하여 회원님이 제공한 은행 계좌에서 주기적으로 인출하도록 승인하게 됩니다. 위에서 승인된 인출 범위를 벗어나는 결제는 회원님의 계좌 또는 비밀번호, 코드, 기타 서명에 상응하는 방법을 통해 승인을 받은 후에만 인출됩니다.\n     ',
  'confirmationPage.labels.termsAch3': '\n     수취인에게 연락하여 언제든지 이 승인을 취소할 수 있습니다. 취소는 다음 정기 결제 일정 최소 [10영업일] 전에 접수되어야 합니다.\n    ',
  'confirmationPage.labels.print': '계약 인쇄',
  'amountPanel.labels.amountFromLabel': '결제할 금액:',
  'amountPanel.labels.surchargeFeeInfo': '카드 수수료 포함',
  'amountPanel.labels.serviceFeeInfo': '서비스 수수료 포함',
  'amountPanel.labels.serviceFeePercentageInfo': '{{percentage}} 서비스 수수료(최소 {{minimumFee}})',
  'amountPanel.labels.serviceFeePercentageOnlyInfo': '{{percentage}} 서비스 수수료',
  'amountPanel.labels.whyThisFee': '왜 이 수수료입니까?',
  'amountPanel.labels.currencyChangeWarning': '통화가 카드 통화와 일치하도록 변경되었습니다',
  'amountPanel.labels.amountToLabel': '{{recipientName}}이(가) 받는 금액',
  'amountPanel.labels.editCurrencySelection': '통화 선택 편집',
  'amountPanel.labels.discountApplied': '{{amount}} 할인 적용',
  'currencyInfoBanner.labels.currencyInfo': '예정된 결제 금액은 <b>{{code}}({{symbol}})</b>(으)로 청구됩니다.',
  'currencyInfoBanner.error.offerNotFound': '사용 가능한 결제 옵션이 없습니다.',
  'AX': '올란드 제도',
  'AD': '안도라',
  'BG': '불가리아',
  'AT': '오스트리아',
  'BE': '벨기에',
  'HR': '크로아티아',
  'CY': '키프로스',
  'CZ': '체코 공화국',
  'DK': '덴마크',
  'EE': '에스토니아',
  'FI': '핀란드',
  'FR': '프랑스',
  'GP': '과들루프',
  'DE': '독일',
  'GR': '그리스',
  'HU': '헝가리',
  'IS': '아이슬란드',
  'IE': '아일랜드',
  'VA': '교황청 (바티칸 시티 국가)',
  'IT': '이탈리아',
  'LI': '리히텐슈타인',
  'LT': '리투아니아',
  'LU': '룩셈부르크',
  'YT': '마요트',
  'MT': '몰타',
  'MQ': '마르티니크',
  'ES': '스페인',
  'NO': '노르웨이',
  'NL': '네덜란드',
  'PL': '폴란드',
  'PT': '포르투갈',
  'SE': '스웨덴',
  'RE': '레위니옹',
  'RO': '루마니아',
  'CH': '스위스',
  'BL': '생 바르텔레미',
  'GB': '영국',
  'MC': '모나코',
  'MF': '세인트 마틴 (프랑스령)',
  'PM': '생 피에르 미클롱',
  'SM': '산 마리노',
  'SK': '슬로바키아',
  'SI': '슬로베니아',
  'GF': '프랑스령 기아나',
  'LV': '라트비아',
  'CA': '캐나다',
  'US': '미국',
  'inlineDialogConfirmation.labels.title': '확인 필요: 취소 절차',
  'inlineDialogConfirmation.labels.body': '정말로 이 프로세스를 취소하시겠습니까?',
  'inlineDialogConfirmation.labels.closeButton': '아니오',
  'inlineDialogConfirmation.labels.confirmButton': '예',
  'priceBreakDown.price.toggle.button': '가격 분석',
  'priceBreakDown.fx.toggle.button': '환율 분석',
  'priceBreakDown.fees': '수수료',
  'priceBreakDown.service_fees': '서비스 수수료',
  'priceBreakDown.card_fees': '카드 수수료',
  'priceBreakDown.exchange.rate': '환율',
  'priceBreakDown.markup.rate': 'ECB 기준 환율 대비 환전 수수료',
  'priceBreakDown.discount': '할인',
  'priceBreakDown.discount.coupon': '할인({{code}})',
  'priceBreakDown.original_amount': '원금',
  'priceBreakDown.total': '총',
  'acceptProposedOfferBanner.textInfo': '이 카드는 적합하지 않습니다. 지원되는 결제 수단으로 진행하려면 \'수락\'을 탭하세요. 또는 ',
  'acceptProposedOfferBanner.textInfoWithoutChangeCard': '이 카드는 적합하지 않습니다. 지원되는 결제 수단으로 진행하려면 \'수락\'을 탭하세요.',
  'acceptProposedOfferBanner.link.option': '카드 변경',
  'acceptProposedOfferBanner.labels.accept': '수락',
  'chooseCurrencyBanner.title': '통화를 선택하십시오',
  'chooseCurrencyBanner.message': '귀하의 카드 통화가 청구 국가 통화와 다릅니다. 이 거래에 사용할 통화를 선택하십시오.',
  'banner.offer.validation.message': '계속하려면 작업을 선택해야 합니다.',
  'instructions.offline.amount.label': '결제할 금액',
  'instructions.offline.reference.label': '조회 번호/지불 ID',
  'instructions.offline.paymentId.label': '결제 ID',
  'instructions.offline.paymentReferenceMissing': '결제 조회 번호가 없습니다',
  'instructions.offline.missing.title': '결제 안내를 생성할 수 없습니다',
  'instructions.offline.missing.message': '다시 시도하세요. 문제가 지속되면 다른 결제 수단을 시도하거나 거래 은행에 문의하세요.',
  'instructions.offline.title': '결제 지침',
  'instructions.offline.understand': '은행에서 직접 송금을 시작해야 한다는 것을 이해합니다.<br />닫으려면 여기를 클릭하세요.',
  'instructions.offline.download.button': '은행 이체 지침 다운로드',
  'instructions.offline.howToBankTransfer': '은행 송금은 어떻게 합니까?',
  'instructions.offline.howToBankTransfer.modal.title': '은행 이체를 완료하는 방법',
  'instructions.offline.howToBankTransfer.modal.intro': '아래는 은행 이체를 완료하는 데 사용할 수 있는 다양한 옵션입니다.',
  'instructions.offline.howToBankTransfer.modal.onlineBankingTitle': '온라인 뱅킹/모바일 뱅킹',
  'instructions.offline.howToBankTransfer.modal.onlineBankingDescription': '온라인 뱅킹이나 은행의 모바일 앱이 있는 경우 계정에 쉽게 로그인하여 직접 이체할 수 있습니다.',
  'instructions.offline.howToBankTransfer.modal.inPersonTitle': '은행 지점 직접 방문',
  'instructions.offline.howToBankTransfer.modal.inPersonDescription': '현지 은행 지점을 직접 방문하여 결제 지침에 있는 필수 계좌 정보를 은행에 제공하여 이체할 수 있습니다.',
  'instructions.offline.howToBankTransfer.modal.telephoneTitle': '전화 이체',
  'instructions.offline.howToBankTransfer.modal.telephoneDescription': '은행에 전화하여 거래를 대신 시작하도록 승인 요청을 할 수 있습니다.',
  'instructions.offline.referenceWarning': '저희가 고객님의 결제를 확인할 수 있도록 이 조회 번호를 포함하셔야 합니다',
  'instructions.offline.dueDateLabel': '자금을 이체하기 전에:',
  'instructions.offline.processingTime': 'Flywire에서 자금 수령: 이체 시작 후 <strong>영업일 기준 2～3일</strong>',
  'elementsInstructions.qr.description': 'QR 코드를 스캔하여 결제 완료',
  'elementsInstructions.qr.payid.description': 'Open your banking app and send to the PayID below. This address is assigned exclusively to your account — payments are matched automatically.',
  'elementsInstructions.qr.scan': '또는 휴대폰 카메라로 스캔',
  'elementsInstructions.qr.waitingForPayment': 'Awaiting payment completion',
  'elementsInstructions.externalAction.generic': '계속 진행하려면 결제를 완료해 주시기 바랍니다.',
  'elementsInstructions.externalAction.mpesa_message_finish_payment_on_phone': 'M-Pesa 결제 요청이 귀하의 휴대폰으로 전송되었습니다.\n계속 진행하려면 결제를 완료해 주시기 바랍니다.',
  'elementsInstructions.redirect.title': 'Complete your payment',
  'elementsInstructions.redirect.description': 'You will be taken to the partner\'s processing platform to complete this payment. Once it is done, you will be redirected to this page again.',
  'elementsInstructions.redirect.button': 'Make your payment',
  'documentCollector.collapsibleTitle': '서류 업로드',
  'documentCollector.uploadingDocument': '문서 업로드 중',
  'documentCollector.deleteFile': '{{fileName}} 삭제',
  'documentCollector.deletingFile': '{{fileName}} 삭제 중',
  'documentCollector.moreInfoModal': '자세한 정보',
  'documentCollector.errorsModal': 'Document warnings',
  'documentCollector.documentList': '문서 목록',
  'documentCollector.upload': '업로드',
  'documentCollector.errorBlockLabel': 'Document warnings',
  'documentCollector.reUpload': '다시 업로드',
  'documentCollector.errorsFoundOne': '{{count}} Warning Found',
  'documentCollector.errorsFoundOther': '{{count}} Warnings Found',
  'documentCollector.validationNote': '<b>파일 업로드 완료!</b> 자동 스캔에서 잠재적인 문제가 감지되었습니다. 문서에 필요한 모든 정보가 포함되어 있다면 이 경고를 무시하세요.',
  'documentCollector.antivirus': '안티바이러스 파일 스캔',
  'documentCollector.antivirusStep': '안티바이러스 파일 스캔 1/2',
  'documentCollector.verifyingStep': '문서 검토 중 2/2',
  'documentCollector.invalidFile': '잘못된 파일이 감지되었습니다. 파일이 비밀번호로 보호되었거나 암호화되었을 수 있습니다. 확인 후 다시 시도하세요.',
  'documentCollector.moreInfo': '자세한 정보',
  'documentCollector.required': '필수 항목',
  'documentCollector.review': '검토',
  'documentCollector.acceptedFileTypes': '허용되는 파일 형식: <b>PDF</b>, <b>PNG</b>, <b>JPG</b>',
  'documentCollector.maxFileSize': '최대 파일 크기: <b>{{maxFileSize}}MB.</b>',
  'documentCollector.acceptedFileAndFileSize': '허용되는 파일 형식: <b>PDF</b>, <b>PNG</b>, <b>JPG</b>. 최대 파일 크기: <b>{{maxFileSize}}MB.</b>',
  'documentCollector.docVerifyError.missingInfo': '문서에 요청한 정보가 모두 포함되어 있는지 확인하세요.',
  'documentCollector.docVerifyError.documentTypeError': '{{documentType}} 형식이 아닌 것 같습니다. 요구 사항을 확인하신 후 필요한 경우 새 파일을 업로드해 주시기 바랍니다.',
  'documentCollector.docVerifyError.documentIdentificationTypeError': '업로드하신 문서는 이번 결제에 선택하신 신분증 유형인 {{documentType}} 형식이 아닌 것 같습니다. 확인 후 필요한 경우 다시 업로드해 주세요.',
  'documentCollector.docVerifyError.documentType.errorNote': '<b>참고</b>: 잘못된 서류를 제출하면 결제 처리가 지연될 수 있습니다. 문서가 유효한 경우에는 이 경고 메시지를 무시하세요.',
  'documentCollector.duplicateFile': '중복된 문서가 감지되었습니다. 각각에 대해 다른 파일을 업로드하세요.',
  'oneOff.savePaymentMethod.label': '향후 결제를 위해 이 결제 방법 저장',
  'lrs.transaction.title': '거래',
  'lrs.transaction.date': '날짜',
  'lrs.transaction.amount': '금액',
  'lrs.transaction.amountHint': '외화 금액',
  'lrs.transaction.adBranch': 'AD 지점의 명칭 및 주소',
  'lrs.transaction.add': '더 많은 거래 추가',
  'lrs.signatureModal.title': '문서에 서명하십시오',
  'lrs.signatureModal.tab.draw': '서명하기',
  'lrs.signatureModal.tab.upload': '서명을 업로드하십시오',
  'lrs.signatureModal.draw.text': '아래 제공된 공간에 마우스나 손가락을 사용하여 서명하고 문서를 수락하세요.',
  'lrs.signatureModal.legalAlert': '서명이 유효하지 않으면 모든 LRS 프로세스가 무효화됩니다. <b>PAN 소유자의 서명</b>으로 서명하세요. 향후 필요 시 확인할 수 있도록 입력한 결제자 이메일 주소로 문서 사본이 발송됩니다. 허용되는 파일 형식: <b>PNG</b>, <b>JPG</b>.',
  'lrs.signatureModal.draw.clear': '삭제',
  'lrs.signatureModal.upload.label': '서명의 이미지 버전을 업로드하세요',
  'lrs.signatureModal.upload.input': '서명을 업로드하십시오',
  'lrs.signatureModal.upload.remove': '제거',
  'lrs.signatureModal.upload.hint': '허용되는 파일 형식: <b>PNG</b>, <b>JPG</b>. 최대 파일 크기: <b>8MB</b>',
  'lrs.signatureModal.upload.typeError': '지원되지 않는 파일 형식입니다. PNG 또는 JPG 파일을 업로드하세요.',
  'lrs.signatureModal.upload.sizeError': '파일 크기는 8MB 미만이어야 합니다',
  'lrs.signatureModal.upload.readError': '파일을 읽을 수 없습니다. 다시 시도하세요.',
  'lrs.signatureModal.confirm': '수락 및 제출',
  'lrs.signatureModal.previewError': '미리보기를 생성하는 동안 문제가 발생했습니다. 다시 시도하세요.',
  'lrs.signatureModal.uploadError': '제출하는 동안 문제가 발생했습니다. 다시 시도해 주십시오.',
  'lrs.previewLink.label': '문서 미리보기',
  'lrs.documents.continueButton': 'LRS 양식 제출 계속',
  'lrs.form.declaration': '자유 송금 제도(Liberalised Remittance Scheme, LRS)에 따라 인도 정부와 인도준비은행(RBI)은 이제 해외 송금 시 LRS 신고서(정식 명칭 &quot;A2 cum LRS Declaration&quot;)를 요구합니다. 은행 이체를 시작하기 전에 LRS 신고서를 제출하는 것은 필수입니다. 그렇지 않으면 결제 처리가 지연될 수 있습니다. 이 단계를 완료하는 방법에 대한 자세한 내용은 <a href=\'https://help.flywire.com/hc/en-us/articles/360012963774\' target=\'_blank\'>여기</a>를 클릭하여 확인하세요.',
  'lrs.form.bankAccountAndStudentInfo.title': '은행 계좌 및 학생 정보',
  'lrs.form.bankAccountAndStudentInfo.text': '자금이 이체될 은행 계좌를 지정해 주세요. 학자금 대출을 받았고 자금이 대출 계좌에서 지급될 예정이라면 대출 계좌 번호를 알려주시기 바랍니다. NRO/NRE 계좌에서의 이체는 허용되지 않습니다. 학생 ID의 경우 학생 ID, 신청 ID 또는 참조 번호를 사용할 수 있습니다.',
  'lrs.form.details.title': '현재 회계연도에 이루어진 국제 거래의 세부 정보',
  'lrs.form.details.text': '현재 회계연도(<b>{{startYear}}년 4월~{{endYear}}년 3월)</b> 동안의 모든 외화 거래 내역을 알려주세요. 거래 내역이 없다면 비워 두세요.',
  'lrs.form.bankAccountNumber': '은행 계좌 번호',
  'lrs.form.studentFullName': '학생 성명',
  'lrs.form.studentId': '학생 ID',
  'lrs.form.required': '필수 항목',
  'lrs.form.signAndSubmit': 'LRS 양식 서명 및 제출',
  'lrs.title': '서류 업로드하고 LRS 양식을 제출',
  'lrs.description': '이 단계가 완료되면 은행 이체 결제 지침이 표시됩니다.',
  'lrs.tabs.documents': '1. 문서 업로드',
  'lrs.tabs.form': '2. LRS 양식 제출',
  'recipientFields.requiredField': '(*) 필수 필드',
  'paymentMethodSelector.loading': '결제 수단을 불러오는 중...',
  'paymentMethodSelector.cards.acceptsDebitAndCredit': '직불카드 및 신용카드 결제 가능',
  'paymentMethodSelector.cards.acceptsDebitOnly': '직불카드 결제 가능',
  'paymentMethodSelector.cards.acceptsCreditOnly': '신용카드 결제 가능',
  'paymentMethodSelector.cards.surchargeWarning': '카드 유형 및 발급 국가에 따라 추가 수수료가 부과될 수 있습니다.',
  'paymentMethodSelector.subtitle.default': '{{methodName}}(으)로 결제',
  'paymentMethodSelector.subtitle.google_pay': '저장된 Google Pay 지갑으로 결제',
  'paymentMethodSelector.subtitle.apple_pay': 'Touch ID 또는 Face ID — Safari 전용',
  'paymentMethodSelector.subtitle.paypal': 'PayPal 계정으로 결제',
  'paymentMethodSelector.subtitle.wechat': 'WeChat으로 결제 — 중국 본토에서 이용 가능',
  'paymentMethodSelector.subtitle.alipay': 'Alipay로 결제',
  'paymentMethodSelector.subtitle.trustly': '오픈뱅킹 결제'
} as const;
export { koKR };
